// extracted by mini-css-extract-plugin
export default {"NewsItem":"index_NewsItem_2DFot","listItem":"index_listItem_BIiBw","text":"index_text_5x-NH"};